import { render, staticRenderFns } from "./FediverseSection.vue?vue&type=template&id=03569dd3"
import script from "./FediverseSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FediverseSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports